import React from "react";
import { Stack, TextField } from "@fluentui/react";
import {
    getDatasourceSettingValue,
    getSettingsFieldsForType,
    isValidSettingsJson,
    setDatasourceSettingValue,
} from "../utilities/datasourceSettingsFields";

interface DatasourceSettingsFieldsProps {
    typeId: number;
    settingsJson: string | undefined | null;
    onChange: (newSettingsJson: string | null) => void;
}

// Typed editor for the Datasource.Settings JSON column. Known types (registry entries in
// datasourceSettingsFields.ts) render labeled fields; unknown types with HasCustomSettings
// fall back to a raw JSON textarea so a server-first deploy never blocks configuration.
const DatasourceSettingsFields: React.FC<DatasourceSettingsFieldsProps> = ({
    typeId,
    settingsJson,
    onChange,
}: DatasourceSettingsFieldsProps) => {
    const fields = getSettingsFieldsForType(typeId);

    if (!fields) {
        return (
            <TextField
                label={"Settings (JSON)"}
                multiline
                rows={4}
                value={settingsJson ?? ""}
                onChange={(_, nv) => onChange(nv?.trim() ? nv : null)}
                errorMessage={isValidSettingsJson(settingsJson) ? "" : "Settings must be a valid JSON object"}
            />
        );
    }

    return (
        <Stack tokens={{ childrenGap: 15 }}>
            {fields.map(field => (
                <TextField
                    key={field.key}
                    label={field.label}
                    placeholder={field.placeholder}
                    description={field.description}
                    required={field.required}
                    value={getDatasourceSettingValue(settingsJson, field.key)}
                    onChange={(_, nv) => onChange(setDatasourceSettingValue(settingsJson, field.key, nv))}
                />
            ))}
        </Stack>
    );
};

export default DatasourceSettingsFields;
